<template>
  <van-overlay :show="value" :z-index="10">
    <div class="wrapper" @click.stop>
      <div class="block">
        <div class="message_small_title">活动说明：</div>
        <div class="message_des">参与活动后，系统将自动获取您的地理位置并点亮所在城市。（每位参与者在同一城市仅可点亮1次，在不同城市可点亮最多3次）。同时，活动还特别设置“助力母校 为爱续航”环节，每一位参与点亮的校友，可以通过在线捐款，支持母校教育事业发展。</div>
        <div class="message_des">让我们共同点亮祝福母校中国民航大学75周年华诞的璀璨星河，传递对母校的深情祝愿！</div>
        <div class="closeM" @click="close">我已了解</div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'MessageDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 100%;
  height: 522px;
  border-radius: 29px;
  background: url("../../assets/message_bg.png") center center no-repeat;
  background-size: cover;
  padding: 164px 28px 0;
  box-sizing: border-box;
  position: relative;

  .closeM {
    margin: 24px auto 0;
    width: 245px;
    height: 47px;
    line-height: 47px;
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    background: linear-gradient(90deg, #1891FE 0%, #0EBDFF 100%);
    border-radius: 11px;
  }

  .message_small_title {
    font-weight: 500;
    font-size: 16px;
    color: #00428E;
  }

  .message_des {
    text-align: justify;
    text-indent: 2em;
    font-size: 16px;
    color: rgba(54, 54, 54, 0.89);
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message/index.vue